import React, { useEffect, useCallback, useState} from 'react';
import {connect} from 'react-redux';
import Notes from 'midi/Notes.js';

const CurrentChord = ({effect, chord, setNoteSelected}) => { 
    let notes = effect.getCurrentChordNotes();
    return (
          <div className="current-chord-viewer">
            Current Chord: <div className="current-chord">{chord.prettyName}</div>
            {notes.map(
                x =>
                    <div className="chord-note">
                      <div className="note-name">{Notes.fromTranspose(x).toString()}</div>
                      <div className="degree">{effect.getNoteDegree(x)}</div>
                    </div>)}
          </div>
    );
};

const mapStateToProps = (state, props) => {
  return {
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(CurrentChord);
